import { endpoint, EndpointError } from 'endpoints/endpoint';

export type ExportLeadsResult = Buffer;
export type ExportLeadsError = EndpointError;

export const exportLogs = endpoint<void, ExportLeadsResult, ExportLeadsError>({
  method: 'GET',
  url: () => `/csv/export-leads`,
});
